import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "itemSelect"]

  connect() {
    console.log("Competition results controller connected")
  }

  handleSelectChange() {
    // При изменении выбранного элемента отправляем форму
    if (this.itemSelectTarget.value) {
      this.submitForm()
    }
  }

  submitForm() {
    // Отправляем форму для обновления страницы
    this.formTarget.submit()
  }
}